import { useCallback, useState } from "react";

// @material-ui/core components
import { Box, Grid, Tooltip, IconButton } from "@material-ui/core";

import { Create, Visibility as VisibilityIcon } from "@material-ui/icons";

import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { columnTextField } from "utils/tables-utils";
import Delete from "@material-ui/icons/Delete";

const columnModel = (setSelectedRow, setTypeView) => [
  columnTextField({
    dataField: "IdSistemaIntegracao",
    text: "Sistema",
    headerAlign: "center",
    align: "center",
  }),
  columnTextField({
    dataField: "Titulo",
    text: "Título release",
    headerAlign: "center",
  }),
  columnTextField({
    dataField: "DataInclusaoFormat",
    text: "Data inclusão",
    headerAlign: "center",
    align: "center",
  }),
  columnTextField({
    dataField: "DataVisualizacaoFormat",
    text: "Data visualização",
    headerAlign: "center",
    align: "center",
  }),
  {
    dataField: "visualizar",
    text: "",
    isDummyField: true,
    headerStyle: { width: 25 },
    formatter: (cell, row) => {
      return (
        <Tooltip title="Visualizar Detalhes da Release">
          <IconButton
            aria-label="view"
            onClick={() => {
              setSelectedRow(row);
              setTypeView("view");
            }}
          >
            <Box
              component={VisibilityIcon}
              width="1.25rem!important"
              height="1.25rem!important"
            />
          </IconButton>
        </Tooltip>
      );
    },
  },
  {
    dataField: "editar",
    text: "",
    isDummyField: true,
    headerStyle: { width: 25 },
    formatter: (cell, row) => {
      return (
        <Tooltip title="Editar release">
          <IconButton
            aria-label="edit"
            onClick={() => {
              setSelectedRow(row);
              setTypeView("edit");
            }}
          >
            <Box
              component={Create}
              width="1.25rem!important"
              height="1.25rem!important"
            />
          </IconButton>
        </Tooltip>
      );
    },
  },
  {
    dataField: "deletar",
    text: "",
    isDummyField: true,
    headerStyle: { width: 45 },
    formatter: (cell, row) => (
      <Tooltip title="Deletar Release">
        <IconButton
          aria-label="delete"
          onClick={() => {
            setSelectedRow(row);
            setTypeView("delete");
          }}
        >
          <Box
            component={Delete}
            width="1.25rem!important"
            height="1.25rem!important"
          />
        </IconButton>
      </Tooltip>
    ),
  },
];

const TableReleases = ({
  dataTable,
  search,
  currentSizePerPage,
  currentPage,
  totalRegistros,
  setSelectedRow,
  setTypeView,
}) => {
  const [loading, setLoading] = useState(false);

  const doSearch = useCallback(async (page, sizePerPage) => {
    setLoading(true);

    await search({ page, sizePerPage });

    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = useCallback(
    (page, sizePerPage) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  const handleSizePerPageChange = useCallback(
    (sizePerPage, page) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  return (
    <>
      <Grid item xs={12}>
        <ToolkitTable
          keyField="IdReleaseSistemaProduto"
          dataTable={dataTable}
          searched={Boolean(dataTable)}
          columnModel={columnModel(setSelectedRow, setTypeView)}
          headerTitle={"Gerenciamento de Releases"}
          pagination={{
            options: [25, 50, 100],
            defaultOption: currentSizePerPage,
            totalSize: totalRegistros,
            showTotal: true,
            page: currentPage,
            onPageChange: handlePageChange,
            sizePerPage: currentSizePerPage,
            onSizePerPageChange: handleSizePerPageChange,
          }}
          loading={loading}
          bootstrapTableProps={{
            remote: true,
            onTableChange: () => {},
          }}
          notFoundTitle="Sua pesquisa não encontrou registros correspondentes."
        />
      </Grid>
    </>
  );
};

export { TableReleases };
